export class LanguageModel {
	public id: string;
	public messageTitle: string;
	public code: string;
	public message: string;
	public fileName: string | null;
	public audioDuration: number;

	public constructor() {
		this.id = "";
		this.messageTitle = "";
		this.code = "";
		this.message = "";
		this.fileName = "";
		this.audioDuration = 0;
	}
}

export default class BatchMessageLanguageDetailModel {
	public preSubmissionConfigurationId: string;
	public languages: LanguageModel[];
	public partitionKey: string;

	public constructor() {
		this.preSubmissionConfigurationId = "";
		this.languages = [];
		this.partitionKey = "";
	}
}
